import { api } from "../../api/api";
import {
  STORE_REQUEST, GET_STORES_SUCCESS, ADD_STORE_SUCCESS,
  UPDATE_STORE_SUCCESS, DELETE_STORE_SUCCESS, STORE_FLAG_OFF,
} from "../constant";

export const getStores = (userId, opts = {}) => async (dispatch) => {
  if (userId == null || userId === '') return;
  dispatch({ type: STORE_REQUEST });
  try {
    const params = new URLSearchParams();
    if (opts.role) params.set('role', opts.role);
    if (opts.subuserId) params.set('subuserId', opts.subuserId);
    if (opts.tljRegion) params.set('tljRegion', opts.tljRegion);
    const q = params.toString();
    const url = q ? `/store/getall/${userId}?${q}` : `/store/getall/${userId}`;
    const { data } = await api.get(url);
    dispatch({ type: GET_STORES_SUCCESS, payload: data.stores || data || [] });
  } catch (e) { console.error(e); dispatch({ type: GET_STORES_SUCCESS, payload: [] }); }
};

export const addStore = (obj) => async (dispatch) => {
  try {
    const { data } = await api.post("/store/add", obj);
    dispatch({ type: ADD_STORE_SUCCESS, payload: data.store });
  } catch (e) { console.error(e); }
};

export const updateStore = (id, obj) => async (dispatch) => {
  try {
    const { data } = await api.patch(`/store/update/${id}`, obj);
    dispatch({ type: UPDATE_STORE_SUCCESS, payload: data.store });
  } catch (e) { console.error(e); }
};

export const deleteStore = (id) => async (dispatch) => {
  try {
    await api.delete(`/store/delete/${id}`);
    dispatch({ type: DELETE_STORE_SUCCESS, payload: id });
  } catch (e) { console.error(e); }
};

export const storeFlagOff = () => ({ type: STORE_FLAG_OFF });

export const createStoreFormLink = (subuserId) => async (dispatch) => {
  const { data } = await api.post("/store/create-form-link", { subuserId });
  return data?.link ?? null;
};
